import React from 'react';
import { compose, withState, lifecycle } from 'recompose';
import { withRouter } from 'react-router';
// import { Auth } from 'aws-amplify';
import { withStyles } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';
import Copyright from '../../components/Copyright';

const styles = theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white
    }
  },
  print: {
    marginTop: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  userImage: {
    margin: '50px'
  }
});

const enhancer = compose(
  withState('qrCode', 'setQrCode', ''),
  lifecycle({
    componentDidMount() {
      this.props.setQrCode(this.props.location.state.qrCode);
    }
  })
);

const login = enhancer(({ classes, qrCode }) => {
  return (
    <Container component="main" maxWidth="xs">
      <div className={classes.print}>
        <Button color="primary" onClick={() => window.print()}>
          このページを印刷してご利用ください。
        </Button>
      </div>
      <div className={classes.paper}>
        <Typography component="h1" variant="h3" align="center">
          ごちめし
        </Typography>
        <Card className={classes.userImage}>
          <CardActionArea>
            <CardMedia component="img" image={qrCode} />
          </CardActionArea>
        </Card>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
});

export default withRouter(withStyles(styles)(login));
